import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "m12.886 11.568 3.853 3.852a1.024 1.024 0 0 1-1.445 1.446l-3.854-3.853a7.12 7.12 0 0 1-4.284 1.427A7.164 7.164 0 0 1 0 7.284 7.164 7.164 0 0 1 7.157.127c3.946 0 7.156 3.21 7.156 7.157a7.118 7.118 0 0 1-1.427 4.283Zm-5.73-9.396a5.112 5.112 0 0 0-5.11 5.112l-.002-.001a5.118 5.118 0 0 0 5.112 5.112 5.112 5.112 0 0 0 0-10.223Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };